import { render } from "./ListCreatePanel.vue?vue&type=template&id=682aaa28"
import script from "./ListCreatePanel.vue?vue&type=script&lang=ts"
export * from "./ListCreatePanel.vue?vue&type=script&lang=ts"
script.render = render

export default script